import { StorageLocationSchema } from "@redotech/redo-fulfillment-wms-common/schema/storage-location";
import { locationIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const getStorageLocationByName = {
  name: "getStorageLocationByName" as const,
  input: z.object({ locationId: locationIdFormat.schema, name: z.string() }),
  output: z.object({ storageLocation: StorageLocationSchema.nullable() }),
};
